export enum AuthProvider {
  Google = 'GOOGLE',
  Facebook = 'FACEBOOK',
  Password = 'PASSWORD',
}

export interface ResetPasswordParams {
  email: string;
  code: string;
  newPassword: string;
}

export interface SignInRequest {
  email: string;
  password: string;
}

export interface SignInResponse {
  user: AuthUser;
  tokens: Tokens;
}

export interface AuthUser {
  id: number;
  email: string;
  providers: string[];
}

export interface Tokens {
  accessToken: string;
  refreshToken: string;
}

export interface SignUpRequest {
  email: string;
  password: string;
}

export interface JwtData {
  sub: number;
  nec: boolean;
  iat: number;
  exp: number;
  type: 'access'; // To verify possibilities
}

export interface GoogleSignInRequest {
  idToken: string;
}

export interface FacebookSignInRequest {
  token?: string;
  code?: string;
  redirectUri?: string;
}

export type SignUpResponse = SignInResponse;
export type ConfirmEmailResponse = SignInResponse;
export type GoogleSignInResponse = SignInResponse;
export type FacebookSignInResponse = SignInResponse;
